module.exports = __webpack_public_path__ + "img/text_hzlh.d5a9b4fc.png";